import ArgTypes from "@bit/fabfitfun.shared.utils.arg-types";

export const args = [
  {
    title: "Shipping Heading",
    key: "shippingTitle",
    type: ArgTypes.STRING
  },
  {
    title: "Box Status Heading",
    key: "boxStatusTitle",
    type: ArgTypes.STRING
  },
  {
    title: "Box Status Billing CTA Text",
    key: "boxStatusBillingCTA",
    type: ArgTypes.STRING
  },
  {
    title: "Box Status Tracking CTA Text",
    key: "boxStatusTrackingCTA",
    type: ArgTypes.STRING
  },
  {
    title: "Refer Heading",
    key: "referTitle",
    type: ArgTypes.STRING
  },
  {
    title: "Refer Description",
    key: "referDescription",
    type: ArgTypes.STRING
  },
  {
    title: "Refer CTA Text",
    key: "referCTA",
    type: ArgTypes.STRING
  },
  {
    title: "Upgrade CTA Text",
    key: "upgradeCTA",
    type: ArgTypes.STRING
  },
  {
    title: "Upgrade Heading",
    key: "upgradeTitle",
    type: ArgTypes.STRING
  },
  {
    title: "Upgrade Description",
    key: "upgradeDescription",
    type: ArgTypes.STRING
  },
  {
    title: "Box Status Processing",
    key: "boxStatuses.BOX_STATUS_PROCESSING",
    type: ArgTypes.STRING
  },
  {
    title: "Box Status Assigned",
    key: "boxStatuses.BOX_STATUS_ASSIGNED",
    type: ArgTypes.STRING
  },
  {
    title: "Box Status Shipped",
    key: "boxStatuses.BOX_STATUS_SHIPPED",
    type: ArgTypes.STRING
  },
  {
    title: "Box Status Delivered",
    key: "boxStatuses.BOX_STATUS_DELIVERED",
    type: ArgTypes.STRING
  },
  {
    title: "Box Status Probably Delivered",
    key: "boxStatuses.BOX_STATUS_PROBABLY_DELIVERED",
    type: ArgTypes.STRING
  },
  {
    title: "Box Status No Box",
    key: "boxStatuses.BOX_STATUS_NO_BOX",
    type: ArgTypes.STRING
  }
];

export default {
  args: args
};



// WEBPACK FOOTER //
// ./src/Components/Header/headerArgs.js